import React from 'react'
import "./Home.css"
import HomeText from './HomeText'
import ProjectCard from '../Project/ProjectCard'
import ServicesCard from '../Service/ServicesCard'

const Home = () => {
  return (
    <div className="homeParent">

      {/* Home Text */}
      <section className="home_text">
        <h1>What You Can Think <br /> We Can Develop It <br /> For You!</h1>
        <p>We create future-ready websites & web apps via innovative digital solutions so that you can focus on your core business.</p>
        <a href="#" className='home_button'>Let's talk</a>
      </section>



      {/* Project */}
      <section className="home_project">

        {/* Project - Text */}
        <HomeText h3="Explore our done" h1="Projects" p="Here are some samples of our done projects delivered to our great clients." li1="Custom Web Development" li2="Content & Copy Writing" li3="Blockchain Web Apps" li4="Graphic Designing" />

        {/* Project - Cards */}
        <div class="card_main">
          <ProjectCard title="Rhenyz" color="-webkit-linear-gradient(270deg, hsla(211, 82%, 35%, 1) 0%, hsla(0, 0%, 0%, 1) 100%)" />
          <ProjectCard title="2584 Design" color="-webkit-linear-gradient(270deg, hsla(180, 83%, 40%, 1) 0%, hsla(0, 0%, 0%, 1) 100%)" />
          <ProjectCard title="Sebrapage" color="-webkit-linear-gradient(270deg, hsla(272, 65%, 37%, 1) 0%, hsla(0, 0%, 0%, 1) 100%)" />
          <ProjectCard title="Automation" color="-webkit-linear-gradient(270deg, hsla(0, 79%, 72%, 1) 0%, hsla(0, 0%, 0%, 1) 100%)" />
        </div>

        <div className='home_project_button'><a href="#" className='home_button'>View More!</a></div>
      </section>



      {/* Offers */}
      <section className='home_project'>
        {/* Offers - Text */}
        <HomeText h3="Services we" h1="Offered" p="Responsive Websites & Web Apps, and Full Stack Web Apps Development" li1="Custom Web Development ( HTML, CSS, JS, ReactJs, Firebase)" li2="Blockchain Web Apps (Minting, Wallet Connectivity, Smart Contract Integration)" li3="Graphic Designing (Professional Business Logo Design, Poster Design, CV Design, Photo Editing)" li4="Content and Copy Writing (Engaging Web Pages, Sales Copy, Product Description, Blogs & Articles)" />

        {/* Offers - Cards */}
        <section className="card_parent">
          <ServicesCard icon="fa-solid fa-desktop" title="Custom Web App" text="We focus on creating a modern, flexible, secure, cross-platform, and user-friendly web app so that it can meet spikes in demand and handle complex scenarios" />

          <ServicesCard icon="fa-solid fa-boxes-stacked" title="Contract Integration / Minting" text="We do smart Contract integration in which includes functionalities minting, whitelist, get data from Blockchain and update on it, buy tokens and etc" />

          <ServicesCard icon="fa-solid fa-wallet" title="Wallet Connectivity" text="We do wallet integration in Blockchain. These wallets include Metamask, Coinbase, Trust, Sollana, etc. We also connect these wallets with the front end" />

          <ServicesCard icon="fa-brands fa-hive" title="Landing Pages" text="We pay special attention to create attention-grabbing landing pages that convince your users to take the required action. We use a combination of eye-catching backgrounds and images to make each section stand out" />
        </section>

        <div className='home_project_button'><a href="#" className='home_button'>View More!</a></div>
      </section>

    </div>
  )
}

export default Home
